import AppLayout from '../layouts/AppLayout.vue'
import { RouteRecordRaw } from 'vue-router'
import Dashboard from '../pages/admin/dashboard/Dashboard.vue'
import ReportPage from '../pages/reports/ReportPage.vue'
import CompanyReport from '../pages/reports/CompanyReport.vue'

export const privateRoutes: Array<RouteRecordRaw> | any = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        meta: {
          title: 'Dashboard',
        },
        component: CompanyReport,
      },
      {
        name: 'preferences',
        path: 'preferences',
        meta: {
          title: 'Preferências',
        },
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      // {
      //   name: 'professionals',
      //   path: 'professionals',
      //   meta: {
      //     title: 'Profissionais',
      //   },
      //   component: () => import('../pages/professionals/ProfessionalsPage.vue'),
      // },
      // {
      //   name: 'add-company',
      //   path: 'add-companies',
      //   meta: {
      //     title: 'Adicionar Empresa',
      //   },
      //   component: () => import('../pages/companies/AddCompanyPage.vue'),
      // },
      // {
      //   name: 'companies',
      //   path: 'companies',
      //   meta: {
      //     title: 'Empresas',
      //   },
      //   component: () => import('../pages/companies/CompaniesPage.vue'),
      // },
      // {
      //   name: 'company',
      //   path: 'companies/:id',
      //   meta: {
      //     title: 'Empresa',
      //   },
      //   component: () => import('../pages/companies/CompanyPage.vue'),
      // },
      // {
      //   name: 'professional',
      //   path: 'professionals/:id',
      //   meta: {
      //     title: 'Profissional',
      //   },
      //   component: () => import('../pages/professionals/ProfessionalPage.vue'),
      // },
      {
        name: 'customers',
        path: 'customers',
        meta: {
          title: 'Clientes',
        },
        component: () => import('../pages/customers/CustomersPage.vue'),
      },
      {
        name: 'customer',
        path: 'customers/:id',
        meta: {
          title: 'Cliente',
        },
        component: () => import('../pages/customers/CustomerPage.vue'),
      },
      // {
      //   name: 'users',
      //   path: 'users',
      //   meta: {
      //     title: 'Usuários',
      //   },
      //   component: () => import('../pages/users/UsersPage.vue'),
      // },
      // {
      //   name: 'user',
      //   path: 'users/:id',
      //   meta: {
      //     title: 'Usuário',
      //   },
      //   component: () => import('../pages/users/UserPage.vue'),
      // },
      // {
      //   name: 'sales',
      //   path: 'sales',
      //   meta: {
      //     title: 'Vendas',
      //   },
      //   component: () => import('../pages/sales/SalesPage.vue'),
      // },
      // {
      //   name: 'add-sale',
      //   path: 'add-sale',
      //   meta: {
      //     title: 'Adicionar Pedido',
      //   },
      //   component: () => import('../pages/sales/AddSalePage.vue'),
      // },
      // {
      //   name: 'sale',
      //   path: 'sales/:id',
      //   meta: {
      //     title: 'Pedido',
      //   },
      //   component: () => import('../pages/sales/SalePage.vue'),
      // },
      // {
      //   name: 'invoices',
      //   path: 'invoices',
      //   meta: {
      //     title: 'Notas Fiscais',
      //   },
      //   component: () => import('../pages/invoices/InvoicesPage.vue'),
      // },
      // {
      //   name: 'invoice',
      //   path: 'invoices/:id',
      //   meta: {
      //     title: 'Nota Fiscal',
      //   },
      //   component: () => import('../pages/invoices/InvoicePage.vue'),
      // },
      // {
      //   name: 'tags',
      //   path: 'tags',
      //   meta: {
      //     title: 'Tags de Produto',
      //   },
      //   component: () => import('../pages/tags/TagsPage.vue'),
      // },
      // {
      //   name: 'reports',
      //   path: 'reports',
      //   meta: {
      //     title: 'Relatórios',
      //   },
      //   component: ReportPage,
      // },
      {
        name: 'companyReports',
        path: 'company-reports',
        meta: {
          title: 'Relatórios de Empresa',
        },
        component: CompanyReport,
      },
    ],
  },
]

export const privateRouteNames = privateRoutes[1].children.map((route: any) => route.name)
